import {REJECTED} from '../actions/constants';
import * as firebase from "../firebase";

export default (state = {}, action) => {
    if(action.type.indexOf(REJECTED) > -1){
        firebase.signOut();
        window.location.href = "/sign-in?session-expired"
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/AuthListenerReducer.js